module.exports = __webpack_public_path__ + "static/media/11.dc4af961.png";